<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">基本信息</span>
      </div>
      <SForm
        ref="formref"
        :url="formurl"
        method="put"
        :fields="formfields"
        :data-form="rowdata"
        :before="formbefore"
        :handle="formhandle"
        label-width="90px"
        :inline="false"
        form-style="width: 500px;"
      />
    </el-card>
  </div>
</template>

<script>
// import x from ''

export default {
  name: 'AddAdministrators',
  components: {},
  data() {
    return {
      formurl: '/user',
      rowdata: {},
      formfields: [
        {
          label: '管理员姓名',
          prop: 'userName',
          placeholder: '请输入管理员姓名',
          rules: { required: true, message: '请输入管理员姓名', trigger: 'blur' }
        },
        {
          label: '管理员账号',
          prop: 'loginName',
          placeholder: '请输入管理员账号',
          rules: { required: true, message: '请输入管理员账号', trigger: 'blur' }
        },
        {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号',
          rules: { required: true, message: '请输入正确的手机号码', pattern: /^1[23456789]\d{9}$/, trigger: 'blur' }
        },
        {
          label: '密码',
          prop: 'password',
          type: 'password',
          placeholder: '请输入密码',
          rules: { required: true, message: '请输入密码', trigger: 'blur' }
        }
      ],

      formbefore: record => {
        console.log(record)
        return record
      },
      formhandle: record => {
        this.$router.go(-1)
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/userManagement/addAdministrators.vue